
export default function About() {
  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          {/* Image */}
          <div className="relative">
            <div className="w-full h-[600px] rounded-lg overflow-hidden shadow-2xl">
              <img
                src="https://public.readdy.ai/ai/img_res/29f7795ddacbb6faec7c75343421ab7a.jpg"
                alt="Hands holding handcrafted wooden bowl"
                className="w-full h-full object-cover object-top"
              />
            </div>
            <div className="absolute -bottom-8 -right-8 w-64 h-64 bg-amber-100 rounded-lg -z-10"></div>
          </div>

          {/* Content */}
          <div>
            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
              Crafted with Passion, Rooted in Tradition
            </h2>
            <p className="text-lg text-gray-700 mb-6 leading-relaxed">
              At Holman Brown Design, we believe every wooden bowl tells a story. Our bespoke handcrafted bowls are more than functional pieces—they are works of art that bring warmth and character to your home.
            </p>
            <p className="text-lg text-gray-700 mb-6 leading-relaxed">
              Each bowl is meticulously crafted from locally sourced wood in northeast Ohio, celebrating the natural beauty and unique grain patterns of our regional forests. We work with sustainable practices, honoring the trees that provide us with such magnificent materials.
            </p>
            <p className="text-lg text-gray-700 mb-8 leading-relaxed">
              Our commitment to bespoke craftsmanship means no two bowls are exactly alike. Every piece is shaped by hand, finished with care, and designed to become a cherished heirloom in your family for generations to come.
            </p>

            {/* Features */}
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
              <div className="flex items-start">
                <div className="w-12 h-12 flex items-center justify-center bg-amber-100 rounded-lg mr-4 flex-shrink-0">
                  <i className="ri-hand-heart-line text-2xl text-amber-700"></i>
                </div>
                <div>
                  <h3 className="text-lg font-semibold text-gray-900 mb-2">Handcrafted Excellence</h3>
                  <p className="text-sm text-gray-600">Every bowl is shaped and finished by skilled artisan hands</p>
                </div>
              </div>

              <div className="flex items-start">
                <div className="w-12 h-12 flex items-center justify-center bg-amber-100 rounded-lg mr-4 flex-shrink-0">
                  <i className="ri-map-pin-line text-2xl text-amber-700"></i>
                </div>
                <div>
                  <h3 className="text-lg font-semibold text-gray-900 mb-2">Locally Sourced</h3>
                  <p className="text-sm text-gray-600">Wood from sustainable forests in northeast Ohio</p>
                </div>
              </div>

              <div className="flex items-start">
                <div className="w-12 h-12 flex items-center justify-center bg-amber-100 rounded-lg mr-4 flex-shrink-0">
                  <i className="ri-star-line text-2xl text-amber-700"></i>
                </div>
                <div>
                  <h3 className="text-lg font-semibold text-gray-900 mb-2">Bespoke Design</h3>
                  <p className="text-sm text-gray-600">Each piece is unique with its own character and beauty</p>
                </div>
              </div>

              <div className="flex items-start">
                <div className="w-12 h-12 flex items-center justify-center bg-amber-100 rounded-lg mr-4 flex-shrink-0">
                  <i className="ri-leaf-line text-2xl text-amber-700"></i>
                </div>
                <div>
                  <h3 className="text-lg font-semibold text-gray-900 mb-2">Sustainable Practice</h3>
                  <p className="text-sm text-gray-600">Committed to environmental responsibility and conservation</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
